module.exports = __webpack_public_path__ + "img/beautify1.fb1ce31c.webp";